import React from 'react';
import Div from '../Div';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import Newsletter from '../Widget/Newsletter';
import SocialWidget from '../Widget/SocialWidget';
import TextWidget from '../Widget/TextWidget';
import './footer.scss';
const copyrightLinks = [
  {
    title: 'Terms of Use',
    href: '/',
  },
  {
    title: 'Privacy Policy',
    href: '/',
  },
];

const serviceMenu = [
  {
    title: 'Software Development',
    href: '',
  },
  {
    title: 'Web & App Development',
    href: '',
  },
  {
    title: 'System Automatization',
    href: '',
  },
  {
    title: 'Software as a Service',
    href: '',
  },
];

export default function Footer({ copyrightText, logoSrc, logoAlt, text }) {
  return (
    <footer className="cs-footer">
                      <br/>
                      <br/>
                      <br/>
                      <br/>
      <Div className="cs-footer_main">
        <Div className="container">
          <Div className="row" style={{ display: "flex", justifyContent: "space-between" }}>
            <Div className="col-lg-4 col-md-4 col-sm-12" style={{ display: "flex", flexDirection: "column" }}>
              <Div className="cs-footer_item">
                <TextWidget
                  logoSrc={logoSrc || "/images/cezzon-white.png"}
                  logoAlt={logoAlt || "Logo"}
                  text={text || "Welcome to Cezzon, where we innovate and build future-ready solutions."}
                />
                <SocialWidget />
              </Div>
            </Div>

            <Div className="col-lg-4 col-md-4 col-sm-12" style={{ display: "flex", flexDirection: "column" }}>
              <Div className="cs-footer_item">
                <br/>
                <br/>
                <ContactInfoWidget title="Contact Us" />
              </Div>
            </Div>

            <Div className="col-lg-4 col-md-4 col-sm-12" style={{ display: "flex", flexDirection: "column" }}>
              <Div className="cs-footer_item">
              <br/>
              <br/>
                <Newsletter
                  title="Subscribe"
                  subtitle="Stay updated with our latest news and exclusive offers."
                  placeholder="Enter your email"
                />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Div className="container">
        <Div className="cs-bottom_footer">
          <Div className="cs-bottom_footer_left">
            <Div className="cs-copyright">
              {copyrightText || "Copyright © 2025 Cezzon. All rights reserved."}
            </Div>
          </Div>
         
        </Div>
      </Div>
    </footer>
  );
}
